import { useAtomValue } from 'jotai';
import { findingsGroupedBySeverityAtom } from '@/hooks/atoms';
import FindingListItem from './FindingListItem';
import SeverityBadge from './SeverityBadge';
import type { Severity } from '@/types/forensics';

const SEVERITY_ORDER: Severity[] = ['high', 'medium', 'low', 'info'];

export default function FindingList() {
  const grouped = useAtomValue(findingsGroupedBySeverityAtom);

  const totalFindings = SEVERITY_ORDER.reduce((sum, s) => sum + grouped[s].length, 0);

  if (totalFindings === 0) {
    return <div className="text-center py-8 text-muted-foreground text-sm">No findings match the current filters.</div>;
  }

  return (
    <div className="space-y-4">
      {SEVERITY_ORDER.map((severity) => {
        const findings = grouped[severity];
        if (findings.length === 0) return null;

        return (
          <div key={severity}>
            <div className="flex items-center gap-2 mb-2">
              <SeverityBadge severity={severity} />
              <span className="text-xs text-muted-foreground">({findings.length})</span>
            </div>
            <div className="space-y-2">
              {findings.map((finding) => (
                <FindingListItem key={finding.id} finding={finding} />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
